import WebFontLoader from "webfontloader";
export default {
    created() {
        this.setAppProcessing(false);
    },
    methods: {
        loadUserFont(user) {
            if (!this.userFontLoaded) {
                let menuFont = new Array();
                menuFont.push(user.font.name + ":400,700");
                WebFontLoader.load({
                    google: {
                        families: menuFont,
                    },
                    active: this.setFontLoaded,
                });
            }
        },
        setFontLoaded() {
            this.setUserFontLoaded(true);
        },
        isColorLight: function (color) {
            const brightness = Math.round(
                (parseInt(color.r) * 299 +
                    parseInt(color.g) * 587 +
                    parseInt(color.b) * 114) /
                    1000
            );
            const isLight = brightness > 125 ? true : false;
            return isLight;
        },
        getMap(value) {
            var temp = document.createElement("div");
            var frag = document.createDocumentFragment();

            temp.innerHTML = value;
            frag.appendChild(temp);
            const frm = temp.getElementsByTagName("iframe");

            if (frm.length) {
                return frm[0].src;
            } else {
                return false;
            }
        },
    },
    metaInfo() {
        return {
            title: this.metaTags.title,
            titleTemplate: this.metaTags.titleTemplate,
            vmid: "title",
            meta: [
                {
                    name: "description",
                    vmid: "description",
                    content: this.metaTags.description,
                },
                {
                    name: "og:title",
                    vmid: "ogTitle",
                    content: this.metaTags.title,
                },
                {
                    name: "og:description",
                    vmid: "ogDescription",
                    content: this.metaTags.description,
                },
            ],
            script: this.metaTags.scripts,
            link: this.metaTags.links,
        };
    },
    watch: {
        showNotification: function (val) {
            if (val) {
                var _self = this;
                let notification = {
                    value: false,
                    type: 0,
                    message: "",
                };
                setTimeout(function () {
                    _self.displayNotification(notification);
                }, 2000);
            }
        },
    },
};
